import { Box } from '@mui/material'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { PageIndex, setPageIndex, setPageName } from '../../store/redux/reducers/pageNameSlice'
import { useAppDispatch } from '../../store/redux/hooks'

const SettingsView = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setPageName(t('page.name.settings')))
    dispatch(setPageIndex(PageIndex.SETTINGS))
  }, [dispatch, t])

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
      }}
    ></Box>
  )
}

export default SettingsView
